export default __webpack_public_path__ + "static/productImageNL-3f58ec124c4012f1950db4043356dc6c.png";